import { createApp } from "vue";

/* Import the SDS components library */
import SdsComponents from "@cmu-sei/sei-design-system"

/* Utilities */
import './observer.ts'

/* Setup Vue application */
import GenericDatepicker from "./GenericDatepicker.vue";
import GenericAvatarGroup from "./GenericAvatarGroup.vue";
import ComponentSorter from "./components/ComponentSorter.vue";

/* Local import, wait for mount element(s) to exist in the DOM. */
import { waitForElem } from "../ts/utils/wait_for_elem"

/* Define a mapping of SDS components to their Vue components */
const components = {
  'sds-datepicker': GenericDatepicker,
  'sds-avatar-group': GenericAvatarGroup,
  'sds-component-sorter': ComponentSorter,
}

/* Mount all SDS components found in the DOM */
waitForElem('[name^="sds-"]').then((matchedElems: NodeList) => {
  matchedElems.forEach((matchedElem: Node) => {
    const children: NodeList = matchedElem.childNodes
    /* Nodes will be in the order: [ text, input, text ], the 'text' is whitespace.
     * Select the input element (children[1]) to get the <input /> tag with component data. */
    const dataInput: HTMLElement = children[1] as HTMLInputElement
    if (dataInput) {
      const dataset: object = dataInput.dataset
      const componentClass = (matchedElem as HTMLElement).getAttribute('name');
      const component = components[componentClass];
      if (component) {
        createApp(component)
          .use(SdsComponents)
          .provide('dataset', dataset)
          .mount(matchedElem as HTMLElement);
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Unknown component class: ${componentClass}`);
      }
    }
  })
})
